module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pro/purchases/purchases-show/purchases-show.component.scss
// module id = ./src/app/views/pro/purchases/purchases-show/purchases-show.component.scss
// module chunks = main